module.exports = __webpack_public_path__ + "img/5.47dc25f7.png";